import { CaseFileStaticItems, ConditionSelectorEnums } from '../../utilities/Constants';
import { IQueryFilterCriteriaSelectedRowProps, QueryFilterCriteriaSelectedRow} from './QueryFilterCriteriaSelectedRow';

const ALL_OPTIONS = [
    {
        label: ConditionSelectorEnums.EqualTo,
        value: ConditionSelectorEnums.EqualTo,
    },
    {
        label: ConditionSelectorEnums.NotEqualTo,
        value: ConditionSelectorEnums.NotEqualTo,
    },
    {
        label: ConditionSelectorEnums.Blank,
        value: ConditionSelectorEnums.Blank,
    },
    {
        label: ConditionSelectorEnums.NotBlank,
        value: ConditionSelectorEnums.NotBlank,
    },
    {
        label: ConditionSelectorEnums.Range,
        value: ConditionSelectorEnums.Range,
    },
];

export const QUAD_BLANK_ONLY_STATIC_ITEMS = [
    CaseFileStaticItems.CaseManager.Id,
    CaseFileStaticItems.LocalCounsel.Id,
];

export interface IQueryFilterCriteriaWrapperProps
    extends Omit<IQueryFilterCriteriaSelectedRowProps, 'conditionOptions'> {
    isQuadScope?: boolean;
}

export function QueryFilterCriteriaWrapper({isQuadScope,  ...props}: IQueryFilterCriteriaWrapperProps) {
    
    const isBlankOnlyField = isQuadScope && QUAD_BLANK_ONLY_STATIC_ITEMS.includes(props.item.staticItemId!);

    const conditionOptions = isBlankOnlyField
        ? ALL_OPTIONS.filter(
              (opt) =>
                  opt.value === ConditionSelectorEnums.Blank ||
                  opt.value === ConditionSelectorEnums.NotBlank
          )
        : ALL_OPTIONS;

    const handleConditionOptionChange = (filters: any[], filterIdx: number) => {
        const updatedFilters = [...filters];
        const filter = updatedFilters[filterIdx];

        //normalize back to what ConditionSelector expects
        if (filter.condition === ConditionSelectorEnums.Blank) {
            filter.condition = true;
        } else if (filter.condition === ConditionSelectorEnums.NotBlank) {
            filter.condition = false;
        }

        props.onConditionOptionChange(updatedFilters, filterIdx);
    };

    return <QueryFilterCriteriaSelectedRow {...props} conditionOptions={conditionOptions} onConditionOptionChange={handleConditionOptionChange} />;
}
